import {createRouter} from '@tanstack/react-router';

import {msal} from '@/lib/azure';
import {queryClient} from '@/lib/react-query';
import {CustomNavigationClient} from '@/utils/CustomNavigationClient';

import {notFoundRoute} from './notFound';
import {routeTree} from './routeTree.gen';

export const router = createRouter({
  routeTree,
  notFoundRoute,

  defaultPreload: false,
  defaultPreloadStaleTime: 0,

  context: {queryClient, msal},

  // Scroll to top on route navigation by default
  scrollRestoration: true,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

// allow msal to use react router instead of native
const navigationClient = new CustomNavigationClient(router.navigate);
msal.setNavigationClient(navigationClient);
